







































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import IProjectOutput from "@/api/models/IProjectOutput";
import IOrderOutput from "@/api/models/IOrderOutput";
import { Company, Office } from "@/api/company-api";
import VDelete from "../components/VDelete.vue";
import SwitchButton from "@/components/SwitchButton.vue";
import ProjectPropertiesForm from "@/components/project/property/ProjectPropertiesForm.vue";
import { EnvironmentMixin } from "@/helpers/environment-mixin";

@Component({
  components: {
    ProjectPropertiesForm,
    VDelete,
    SwitchButton
  }
})
export default class ProjectEdit extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) project!: IProjectOutput;
  @Prop({ required: true }) order!: IOrderOutput;
  @Prop({ required: true }) company!: Company;
  @Prop({ required: true }) office!: Office;
  @Prop({ default: () => [] }) clientOptions!: SelectOption[];
  @Prop({ default: () => [] }) clientStaffOptions!: SelectOption[];
  @Prop({ default: () => [] }) templateOptions!: SelectOption[];

  status = "";

  get service() {
    return this.$store.state.service;
  }

  ok() {
    if (
      this.project.templateId &&
      !confirm("工程表のテンプレートを反映してもよろしいですか？")
    ) {
      return;
    }
    this.status = "progressing";
    this.$emit("ok");
  }

  cancel() {
    this.$emit("cancel");
  }

  remove() {
    this.$emit("remove");
  }
}
